export default __webpack_public_path__ + "static/media/Christmas_3_2.aa55781e.png";